<template>
  <el-container class="first">
    <el-header style="height: 12%">
      <div class="tuchu">
        <span style="color: white;margin-right: 10px">您好，{{ name }} ！</span>
        <!-- <el-button type="text" size="small" @click="xiugai">修改密码</el-button> -->
        <el-button type="danger" size="small" @click="tuichu">退出登录</el-button>
      </div>

    </el-header>
    <el-container style="height: 78%;">
      <el-aside width="200px">
        <el-menu style="margin-top: 11px" :default-active="$route.path" class="el-menu-vertical-demo" router
          unique-opened :collapse-transition="false" background-color="#fff" text-color="#373737"
          active-text-color="#ffd04b">
          <el-submenu :index="item.id + ''" v-for="(item, index) in menulist" :key="index">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span style="font-size: 15px;">{{ item.authName }}</span>
            </template>
            <el-menu-item :index="subItem.path" v-for="subItem in item.children" :key="subItem.path">
              <span style="font-size: 13px;">
                {{ subItem.name }}
              </span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>

      <el-main style="height:100%;">
        <router-view>
        </router-view>
     <!-- <div class="shouye">
          <img src="../images/welcome.png" style="width: 40%;height: 60%;">
        </div> -->
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      name:'',
      menulist: [
        {
          id: 0,
          authName: "会员信息管理",
          icon: "el-icon-dog",
          children: [
            {
              id: 0 - 1,
              name: "会员管理",
              path: "/customer",
            },
          ],
        },

        {
          id: 1,
          authName: "课程管理",
          icon: "el-icon-dog",
          children: [
            {
              id: 0 - 1,
              name: "基本信息库",
              path: "/sortAndTag",
            },
            {
              id: 0 - 2,
              name: "添加课程",
              path: "/course",
            },
            {
              id: 0 - 3,
              name: "课程总览",
              path: "/course_table",
            },


          ],
        },

        {
          id: 2,
          authName: "活动管理",
          icon: "el-icon-dog",
          children: [
            {
              id: 0 - 1,
              name: "活动发布",
              path: "/Activityadd",
            },
            {
              id: 0 - 2,
              name: "活动总览",
              path: "/Activity",
            },
          ],
        },

        {
          id: 3,
          authName: "核销课程",
          icon: "el-icon-dog",
          children: [
            {
              id: 0 - 1,
              name: "核销管理",
              path: "/hexiao",
            }
          ],
        },
      ],
    };
  },
  mounted(){
    this.name = localStorage.getItem('username')
  },
  methods:{
    tuichu(){
      localStorage.removeItem('token');
      this.$router.push('/login')
    }
  }
};
</script>

<style lang='scss' scoped>
.first {
  width: 100%;
  height: 100%;
}

.el-header {
  position: relative;
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  height: 100%;
  width: 100%;
  background: url('../images/header.png');
  background-size: cover;
  /* 背景图片覆盖整个元素 */
  background-position: center;
  /* 背景图片居中 */
  background-repeat: no-repeat;
  /* 背景图片不重复 */
}

// .tuchu {
//   position: absolute;
//   right: 0;
//   transform: translateX(42%) translateY(-15%);
//   top: 50%;
//   width: 100%;
//   height: 100%;
// }

.tuchu{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.el-aside {
  background-color: #fff;
  color: #333;
  text-align: left;
  height: 100%;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  // line-height: 160px;
}

.el-menu-item.is-active {
  background: #e6eeff !important;
  color: #3460ff !important;
  border-left: 6px solid #3460ff !important;
}

.el-main {
  padding-top: 0;
}

.shouye {
  width: 100%;
  height: 100%;
  background-color: #fff;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>